module.exports = ({
    "CDMS801TT001": "ชุดข้อมูล",
    "CDMS801TT002": "ประวัติชุดข้อมูล",
    "CDMS801LB001": "รูปแบบการส่งออกข้อมูล",
    "CDMS801LB002": "สถานะ",
    "CDMS801H001": "สถานวิจัย",
    "CDMS801H002": "รหัสผู้ใช้งาน",
    "CDMS801H003": "Visit",
    "CDMS801H004": "เลือก Source",
    "CDMS801H005": "เลือก Domain",
    "CDMS801H006": "รหัสผู้ใช้งาน",
    "CDMS801H007": "ชื่อผู้ใช้งาน",
    "CDMS801H008": "วันที่เริ่มต้น",
    "CDMS801H009": "วันที่สิ้นสุด",
    "CDMS801H010": "ไฟล์",
    "CDMS801H011": "สถานะ",
    "CDMS801H012": "โดเมน",
    "CDMS801BTN001": "ดาวน์โหลด Excel",
    "CDMS801BTN002": "ดาวน์โหลด CSV",
    "CDMS801BTN003": "ดาวน์โหลด Access",
    "CDMS801BTN004": "ดาวน์โหลด SAS",
    "CDMS801BTN005": "ประวัติการดาวน์โหลด",
    "CDMS801BTN006": "ไปที่หน้าข้อมูลชุดข้อมูล",
    "CDMS801OPT001": "Code",
    "CDMS801OPT002": "Label",
    "CDMS801OPT003": "Code & Label",
    "CDMS801OPT004": "SDV",
    "CDMS801OPT005": "Review",
    "CDMS801OPT006": "Freeze",
    "CDMS801OPT007": "Lock",
    "CDMS801OPT008": "eSign",
    "CDMS801OPT009": "ข้อมูลที่กรอก",
    "CDMS801OPT010": "ข้อมูลของระบบ",
    "CDMS801OPT011": "Audit Trail"
});
